import { useEffect } from "react";
import { isCovered } from "../lib/coverage";

/**
 * 열린 말풍선의 트리거가 스크롤로 **가려지면**(고정 헤더 밑으로 들어가거나 스크롤 상자 밖으로 잘리거나 화면 밖으로 나가면) 닫는다.
 * 2026-09-27 말풍선 전수조사 — Portal 로 띄운 말풍선(z 1500)은 고정 헤더(z 1000)보다 위라, 트리거가 헤더 밑으로 들어가도
 * 말풍선만 헤더 위에 떠 있었다. popper 의 「가려짐」 판정은 헤더를 모르므로 여기서 직접 본다.
 * 말풍선 자신(contentRef)이 트리거를 덮는 경우는 가려짐으로 치지 않는다.
 */
export default function useCloseWhenTriggerCovered({ isOpen, onClose, triggerRef, contentRef }) {
  useEffect(() => {
    if (!isOpen || typeof window === "undefined") return undefined;
    let raf = 0;
    const check = () => {
      raf = 0;
      const el = triggerRef?.current;
      if (!el || typeof el.getBoundingClientRect !== "function") return;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      if (isCovered(el, r, { ignore: contentRef?.current || null })) onClose();
    };
    const schedule = () => { if (!raf) raf = window.requestAnimationFrame(check); };
    window.addEventListener("scroll", schedule, true);
    window.addEventListener("resize", schedule);
    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      window.removeEventListener("scroll", schedule, true);
      window.removeEventListener("resize", schedule);
    };
  }, [isOpen, onClose, triggerRef, contentRef]);
}
